import Highlight from '../components/Highlight';

const Installation = () => {
  return (
    <div>
      <p>
        <code>vuex-but-for-react</code> is a lightweight global state management solution for React, heavily resembling
        vuex in its implementation. It's dependent on <code>React</code>, using the
        Context API and <code>useSyncExternalStore</code> under the hood.
      </p>

      <h3>Yarn</h3>
      <Highlight language="shell" code="yarn add vuex-but-for-react" />

      <h3>NPM</h3>
      <Highlight language="shell">
        npm install vuex-but-for-react --save
      </Highlight>

      <p>
        The usage, as the name suggests, is very similar to Vue's <code>vuex</code>, following the <strong>single state
        tree</strong> philosophy and using vuex's store structure and naming.
      </p>

      <p>
        <a href="https://github.com/DJanoskova/vuex-but-for-react" target="_blank" rel="noreferrer">
          vuex-but-for-react on GitHub
        </a>
      </p>
    </div>
  )
}

export default Installation;
